export const Colors = {
    'background': '#1A1A1A',

    // ADD THE OTHER COLORS
    'Primary': '#A71406',
    'Secondary': '#262F42',
    'TextBody': '#D2D8F2'
}